var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"lg":"12"}},[_c('losses-main')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }